import styled from 'styled-components';
import ReactTooltip from 'react-tooltip';
import {
  Box, Text, Button,
} from 'grommet';
import { AppButton } from '@Components/Control';

const StyledRaisedContainer = styled(Box)`
  border-radius: var(--app-radius);
  box-shadow: var(--elevation);
  background-color: ${({ bgColor }) => bgColor ?? 'white'};
`;

const StyledBodyText = styled(Text)`
  color: ${({ textColor }) => textColor ?? 'var(--page-primary-text)'};
  line-height: 1.5;
`;

const StyledStepButton = styled(Button)`
  display: inline-flex;
  align-items: center;
  white-space: nowrap;
  background-color: ${({ bgColor }) => bgColor};
  border-radius: var(--app-radius);
  padding: 0.5rem;
  width: ${({ isSmall }) => (isSmall ? '100%' : 'fit-content')};

  & .step-label {
    color: ${({ labelColor }) => labelColor};
  }

  & .step-number > span {
    color: ${({ stepNumberColor }) => stepNumberColor};
  }

  &:hover:not([disabled]) {
    background-color: ${({ hoverBg }) => hoverBg};
    color: ${({ hoverTextColor }) => hoverTextColor};
  }

  &:hover .step-label {
    color: ${({ hoverTextColor }) => hoverTextColor};
  }

  &:hover .step-number > span {
    color: ${({ isActive, hoverTextColor }) => (isActive ? 'white' : hoverTextColor)};
  }
`;

const StyledServiceOptionContainer = styled(Box)`
  display: flex;
  align-items: flex-start;
  background: ${({ active, hoverBg }) => (active ? hoverBg : 'var(--page-input-bg)')};
  border: 1px solid
    ${({ active, highlightColor }) => (active ? highlightColor : 'var(--button-border)')};
  border-color: ${({ active, highlightColor }) => (active ? highlightColor : 'var(--button-border)')};
  cursor: ${({ noHover }) => (noHover ? 'default' : 'pointer')};
  transition: 0.2s;
  box-shadow: ${({ active }) => (active ? 'var(--elevation-active)' : 'none')};
  outline: none;

  ${({ noHover }) => !noHover && `
    &:hover {
      border-color: ${({ highlightColor }) => highlightColor};
      background: ${({ hoverBg }) => hoverBg};
      transform: translateY(-1px);

      input[type="checkbox"] + div {
        border-color: ${({ highlightColor }) => highlightColor};
      }
    }
  `};
`;

const StyledAccountTypeOption = styled(Box)`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  background: ${({ active, hoverBg }) => (active ? hoverBg : 'var(--page-input-bg)')};
  border: 1px solid ${({ active, highlightColor }) => (active ? highlightColor : 'var(--button-border)')};
  box-shadow: ${({ active }) => (active ? 'var(--elevation-active)' : 'none')};
  cursor: pointer;
  transition: 0.2s;
  min-width: 0;

  &:hover {
    border-color: ${({ highlightColor }) => highlightColor};
    background: ${({ hoverBg }) => hoverBg};
    transform: translateY(-1px);
  }

  @media (min-width: 48.0625em) and (max-width: 64em) {
    min-width: 280px;
  }
`;

const StyledPlanOption = styled(Box)`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  background: ${({ active, hoverBg }) => (active ? hoverBg : 'var(--page-input-bg)')};
  border: 1px solid ${({ active, highlightColor }) => (active ? highlightColor : 'var(--button-border)')};
  box-shadow: ${({ active }) => (active ? 'var(--elevation-active)' : 'none')};
  cursor: pointer;
  transition: 0.2s;
  flex: 1;

  &:hover {
    border-color: ${({ highlightColor }) => highlightColor};
    background: ${({ hoverBg }) => hoverBg};
    transform: translateY(-1px);
  }

  @media (min-width: 48.0625em) and (max-width: 64em) {
    min-width: 280px;
  }
`;

const StyledPlatformTag = styled(Box)`
  cursor: pointer;
  transition: 0.2s;
  margin-bottom: 0.5rem;
  margin-right: 0.5rem;
  border: 1px solid ${({ active, highlightColor }) => (active ? highlightColor : 'var(--button-border)')};
  background: ${({ active, highlightColor }) => (active ? highlightColor : 'var(--page-input-bg)')};
  box-shadow: ${({ active }) => (active ? 'var(--elevation-active)' : 'none')};

  &:hover {
    border-color: ${({ highlightColor }) => highlightColor};
    background: ${({ active, highlightColor, hoverBg }) => (active ? highlightColor : hoverBg)};
    transform: translateY(-1px);
  }
`;

const StyledStepTooltip = styled(ReactTooltip)`
  font-family: inherit;
  border-radius: 6px;
  opacity: 1 !important;
  padding: 0.5rem 0.75rem !important;
  line-height: 1.4 !important;
  max-width: 300px;
  white-space: normal !important;
  word-wrap: break-word !important;
  text-align: left !important;
`;

const StyledUppercaseText = styled(Text)`
  letter-spacing: normal;
`;

const StyledStrikethroughText = styled(Text)`
  text-decoration: line-through;
`;

const StyledResponsiveContainer = styled(Box)`
  @media (max-width: 48em) {
    min-width: 100%;
    max-width: 100%;
  }

  @media (min-width: 48.0625em) {
    min-width: 280px;
    max-width: none;
  }
`;

const StyledFlexContainer = styled(Box)`
  justify-content: stretch;
`;

const StyledFlexText = styled(Text)`
  flex: 1;
`;

const StyledNowrapButton = styled(AppButton)`
  white-space: nowrap;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
`;

export {
  StyledRaisedContainer,
  StyledBodyText,
  StyledStepButton,
  StyledAccountTypeOption,
  StyledServiceOptionContainer,
  StyledPlanOption,
  StyledPlatformTag,
  StyledStepTooltip,
  StyledUppercaseText,
  StyledStrikethroughText,
  StyledResponsiveContainer,
  StyledFlexContainer,
  StyledFlexText,
  StyledNowrapButton,
};
